export default __webpack_public_path__ + "static/media/headphone.620b5b65.svg";